import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import styles from './colorOption.module.scss';
export function ColorOption({ color, title, isSelected, onClick, }) {
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200", alignItems: "center" }, { children: [_jsx(Box, { onClick: onClick, style: { background: color }, className: classNames(styles.colorBox, {
                    [styles.colorBoxSelected]: isSelected,
                }) }), _jsx("div", Object.assign({ className: styles.title }, { children: title }))] })));
}
